import { useCallback, useEffect, useState } from "react";
import { ChevronRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { derashConst, derashEndpoints } from "../utils/derashConstants";
import {
  parseAndroidMessage,
  sendAndroidMessage,
} from "../services/androidBridge";

const parseValue = (value) =>
  typeof value === "string" ? JSON.parse(value) : value;

const languageIndex = (language) => {
  const index = Number(language);
  return Number.isInteger(index) && index >= 0 && index <= 5 ? index : 0;
};

const DerashBillers = () => {
  const [billers, setBillers] = useState([]);
  const [language, setLanguage] = useState(0);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const content = derashConst[languageIndex(language)];

  const handleAndroidMessage = useCallback((message) => {
    const incoming = parseAndroidMessage(message);

    if (incoming.name === "jwt") {
      setLanguage(incoming.data);
      return;
    }

    if (incoming.name !== "response" || !incoming.url?.includes(derashEndpoints.billers)) {
      return;
    }

    const { data, status, desc } = parseValue(incoming.data);

    if (status !== true) {
      setError(desc);
      return;
    }

    setBillers(data.items ?? []);
  }, []);

  useEffect(() => {
    const previousReceiver = window.receiveDataFromAndroid;
    window.receiveDataFromAndroid = handleAndroidMessage;
    sendAndroidMessage("first", "first");
    sendAndroidMessage("requestPost", derashEndpoints.billers, { data: { tenant: "SCUL" }});

    return () => {
      if (window.receiveDataFromAndroid === handleAndroidMessage) {
        window.receiveDataFromAndroid = previousReceiver;
      }
    };
  }, [handleAndroidMessage]);

  useEffect(() => {
    sendAndroidMessage("title", "title", { data: content.title });
  }, [content.title]);

  const selectBiller = (biller) => {
    const searchParams = new URLSearchParams({
      billerCode: biller.billerCode,
      billerName: biller.billerName,
    });

    navigate(`/derash/payment?${searchParams.toString()}`);
  };

  return (
    <main className="service-screen w-full max-w-md mx-auto p-4">
      <section className="border border-gray-300 rounded-xl shadow-lg p-6 bg-white">
        <h1 className="mb-4 text-lg font-semibold text-gray-800">
          {content.billersTitle}
        </h1>

        {error && <p className="text-sm text-red-600">{error}</p>}

        <ul className="space-y-3" aria-label={content.billersTitle}>
          {billers.map((biller) => (
            <li key={biller.billerCode}>
              <button
                type="button"
                onClick={() => selectBiller(biller)}
                className="biller-list-row flex w-full items-center gap-3 rounded-xl border border-slate-200 p-3 text-left transition hover:border-[#7eacdf] hover:bg-[#f8fbff]"
              >
                <span className="min-w-0 flex-1">
                  <span className="block font-semibold text-slate-800">
                    {biller.billerName}
                  </span>
                  <span className="block text-sm text-slate-500">
                    {biller.billerCode}
                  </span>
                </span>
                <ChevronRight className="text-slate-400" size={18} aria-hidden="true" />
              </button>
            </li>
          ))}
        </ul>
      </section>
    </main>
  );
};

export default DerashBillers;
